import { render, staticRenderFns } from "./MaterialShipment.vue?vue&type=template&id=04b637c6&"
import script from "./MaterialShipment.vue?vue&type=script&lang=js&"
export * from "./MaterialShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports